import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight } from "react-icons/md";
import { toast } from "react-toastify";

import Response_Processing from "../../layout/Others/Response_Processing";
import NoRecordTable from "../../components/CommonComponents/NoRecordTable";
import AdminNavbar from "../../components/CommonComponents/AdminNavbar";
import AdminDeleteModal from "../../components/CommonComponents/AdminDeleteModal";
import Defaultloadinggif from "../../layout/Others/Defaultloadinggif";
import MessageBox from "../../components/CommonComponents/MessageBox";
import { ActionFormatterComponent } from "../../components/CommonMethod/CommonBoostrapFormatter";
import { getItemToken } from "../../Utils/localStorageUtils";
import { RxReload } from "react-icons/rx";
import ExportIcon from "../../components/Images/icons/Export_Icon_01.png";
import { IoClose } from "react-icons/io5";
import { donwloadCSV, downloadPDF, downloadXLSX } from "../../components/CommonMethod/CommonMethods";

const DeviceCropRuleList = () => {
  const baseURL = process.env.REACT_APP_Baseurl;
  const headers = getItemToken("access_token");

  const defaultURL = {
    listApi: `${baseURL}/admin/device-crops/index`,
    fetchArrayName: "data",
    multiDeleteApi: `${baseURL}/admin/device-crops/multi-delete`,
    reqBodyName: { deleteName: "ids" },
    addRouteLink: "/add-device-crop-rule",
    editRouteLink: "/edit-device-crop-rule/",
  };

  const [apiData, setApiData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showOverlay, setShowOverlay] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [modelClose, setModelClose] = useState(false);
  const [itemToDelete, setItemToDelete] = useState([]);
  const [filter, setFilter] = useState("");
  const [reloading, setReloading] = useState(false);
  const [orientations, setOrientations] = useState([]);

  const orientationMap = useMemo(() => {
    const map = {};
    orientations.forEach(o => {
      map[o.id] = o;
    });
    return map;
  }, [orientations]);

  const fetchOrientations = async () => {
    try {
      const resp = await axios.get(`${baseURL}/admin/orientation/index`, { headers });
      setOrientations(resp?.data?.data || []);
    } catch (err) {
      // non-blocking
    }
  };

  const fetchData = async (type) => {
    setLoading(true);
    try {
      const response = await axios.get(`${defaultURL.listApi}`, { headers });
      const result = response?.data?.[defaultURL.fetchArrayName] || [];

      if (type === "CSV") await donwloadCSV(result, "DEVICE-CROP-RULES");
      if (type === "PDF") await downloadPDF(result, "DEVICE-CROP-RULES", ["DEVICE", "CODE", "ORIENTATION", "SIZE", "ACTIVE"]);
      if (type === "XLSX") await downloadXLSX(result, "DEVICE-CROP-RULES", ["DEVICE", "CODE", "ORIENTATION", "SIZE", "ACTIVE"]);

      setApiData(result);
      setFilteredData(result);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to fetch crop rules");
    } finally {
      setLoading(false);
      setShowOverlay(false);
    }
  };

  useEffect(() => {
    fetchOrientations();
    fetchData();
  }, []);

  const columns = [
    {
      dataField: "device",
      text: "Device",
      formatter: (cell) => <MessageBox text={String(cell || "").toUpperCase()} />,
      headerStyle: { width: "120px" },
    },
    {
      dataField: "code",
      text: "Code",
      formatter: (cell) => <MessageBox text={cell} />,
    },
    {
      dataField: "orientation_id",
      text: "Orientation",
      formatter: (cell) => {
        const o = orientationMap[cell];
        const label = o ? `${o.slug || o.name}${o.images_size ? ` (${o.images_size})` : ""}` : cell;
        return <MessageBox text={label} />;
      },
    },
    {
      dataField: "size",
      isDummyField: true,
      text: "Size",
      formatter: (_cell, row) => {
        const label = `${row.width}x${row.height}`;
        return <MessageBox text={label} />;
      },
      headerStyle: { width: "120px" },
    },
    {
      dataField: "active",
      text: "Active",
      formatter: (cell) => <MessageBox text={Number(cell) === 1 ? "Yes" : "No"} />,
      headerStyle: { width: "90px" },
    },
    {
      dataField: "ACTIONS",
      text: "Actions",
      formatter: (cell, row) => (
        <ActionFormatterComponent cell={cell} row={row} link={defaultURL.editRouteLink} action={singleDelete} />
      ),
      headerStyle: { width: "180px" },
    },
  ];

  const sizePerPageRenderer = ({ options, currSizePerPage, onSizePerPageChange }) => (
    <div className="btn-group" role="group">
      <select
        className="form-select custom-page-select"
        value={currSizePerPage}
        onChange={(e) => onSizePerPageChange(e.target.value)}
      >
        {options.map((opt) => (
          <option key={opt.page} value={opt.value}>
            {opt.text}
          </option>
        ))}
      </select>
    </div>
  );

  const options = {
    sizePerPageRenderer,
    paginationSize: 4,
    sizePerPage: 10,
    nextPageText: "Next",
    prePageText: "Prev",
    firstPageText: (
      <span>
        <MdKeyboardDoubleArrowLeft />
      </span>
    ),
    lastPageText: (
      <span>
        <MdKeyboardDoubleArrowRight />
      </span>
    ),
    showTotal: true,
    alwaysShowAllBtns: true,
  };

  const selectRow = {
    mode: "checkbox",
    onSelect: (row, isSelect) => {
      if (!row) return;
      if (isSelect) setItemToDelete([...itemToDelete, row.id]);
      else setItemToDelete(itemToDelete?.filter((id) => id !== row?.id));
    },
    style: { width: "50px" },
    selected: itemToDelete,
    selectionHeaderRenderer: ({ checked }) => (
      <div>
        <input type="checkbox" checked={checked} onChange={handleAll} />
      </div>
    ),
  };

  const closeModal = () => {
    setModelClose(false);
    setItemToDelete([]);
  };

  const openModal = () => setModelClose(true);

  const singleDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
  };

  const handleDeletedata = () => {
    handleConfirmDelete();
    closeModal();
  };

  const handleConfirmDelete = async () => {
    setShowOverlay(true);
    try {
      const response = await axios.delete(`${defaultURL.multiDeleteApi}`, {
        headers,
        data: { [defaultURL.reqBodyName.deleteName]: [...itemToDelete] },
      });
      const result = response?.data;
      if (result?.status) {
        toast.success(result?.message || "Deleted successfully");
        setItemToDelete([]);
        await fetchData();
      } else {
        toast.error(result?.message || "Delete failed");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Delete request failed");
    } finally {
      setShowOverlay(false);
    }
  };

  const handleAll = () => {
    const newValue = !selectAll;
    setSelectAll(newValue);
    setItemToDelete(newValue ? filteredData?.map((item) => item?.id) : []);
  };

  const handleFilter = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    setFilter(searchTerm);
    if (searchTerm.trim() === "") {
      setFilteredData(apiData);
      return;
    }
    const filteredResults = apiData.filter((item) => {
      const orientationLabel = (() => {
        const o = orientationMap[item.orientation_id];
        return o ? `${o.slug || o.name}${o.images_size ? ` (${o.images_size})` : ""}` : "";
      })().toLowerCase();
      const fields = [
        String(item.device || ""),
        String(item.code || ""),
        String(item.width || ""),
        String(item.height || ""),
        orientationLabel,
      ];
      return fields.some((v) => v.toLowerCase().includes(searchTerm));
    });
    setFilteredData(filteredResults);
  };

  const handleClear = () => {
    setFilter("");
    setFilteredData(apiData);
  };

  const reloadAction = async () => {
    setReloading(true);
    await new Promise((resolve) => setTimeout(resolve, 600));
    try {
      const response = await axios.get(`${defaultURL.listApi}`, { headers });
      const result = response?.data?.[defaultURL.fetchArrayName] || [];
      setApiData(result);
      setFilteredData(result);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Refresh failed");
    } finally {
      setReloading(false);
    }
  };

  if (showOverlay) return <Defaultloadinggif className="heightOnLoader" />;

  return (
    <>
      {showOverlay && <Response_Processing />}
      {modelClose && (
        <AdminDeleteModal
          modelClose={modelClose}
          deleteClose={closeModal}
          deleteAction={handleDeletedata}
          buttonText={itemToDelete?.length}
        />
      )}

      <AdminNavbar
        heading={"Device Crop Rules"}
        totalDataLength={apiData?.length}
        deleteCount={itemToDelete?.length}
        navigation={defaultURL.addRouteLink}
        deleteMethod={openModal}
        navText={"Add Crop Rule"}
      />

      <div className="theme-bg-color p-3 rounded-2 bootstrapTable multi-delete-width">
        <div className="d-flex align-items-center flex-wrap justify-content-between mb-3">
          <div className="filterContainer">
            <input
              type="text"
              id="filter-search"
              placeholder="Search the list "
              className="filter form-control theme-text-color theme-border-secondary  theme-bg-color-secondary"
              value={filter}
              onChange={handleFilter}
            />
            {filter?.length > 0 && (
              <button type="button" className="clearBtn" onClick={handleClear}>
                <IoClose className="custom-close-btn" />
              </button>
            )}
          </div>
          <div className="d-flex align-items-center">
            <button
              id="reloadButton"
              className={`bg-transparent  custom-tool-tip-parent reloadButton theme-text-color p-2 me-2  border border-2 rounded-circle theme-border-color `}
              onClick={reloadAction}
            >
              <RxReload style={{ width: "18px", height: "15px" }} className={`${reloading ? "rotate-load" : ""}`} />
            </button>

            <div className="dropdown d-block ms-2 " key={"2"}>
              <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="exportAllButton" data-bs-toggle="dropdown" aria-expanded="false">
                <span className="fw-bolder text-white">Export All</span>
                <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
              </button>
              <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportAllButton">
                <li id="exportallCSV" className="dropdown-item theme-text-color" onClick={() => fetchData("CSV", "ALL")}>
                  CSV
                </li>
                <li id="exportallPDF" className="dropdown-item theme-text-color" onClick={() => fetchData("PDF", "ALL")}>
                  PDF
                </li>
                <li id="exportallXLSX" className="dropdown-item theme-text-color" onClick={() => fetchData("XLSX", "ALL")}>
                  XLSX
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div style={{ position: "relative" }}>
          {reloading && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(255,255,255,0.6)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 10,
              }}
            >
              <Defaultloadinggif />
            </div>
          )}
          <BootstrapTable
            keyField="id"
            id="All-device-crops"
            data={filteredData}
            columns={columns}
            pagination={paginationFactory(options)}
            className="no-border-table theme-text-color"
            noDataIndication={<NoRecordTable result={filteredData?.length} loader={loading} />}
            hover
            headerClasses="videoWidth"
            selectRow={selectRow}
            selectAll={selectAll}
          />
        </div>
      </div>
    </>
  );
};

export default DeviceCropRuleList;

